const topicItems = [
  { tag: '斗破苍穹完结', heat: '9.8万讨论' },
  { tag: '下拉式阅读体验', heat: '8.5万讨论' },
  { tag: '漫画全集推荐', heat: '7.2万讨论' },
  { tag: '玄幻漫画排行', heat: '6.8万讨论' },
  { tag: '完结漫画补番', heat: '5.9万讨论' },
  { tag: '免费漫画大全', heat: '5.3万讨论' },
  { tag: '热血漫画经典', heat: '4.7万讨论' },
  { tag: '修仙漫画合集', heat: '4.2万讨论' },
  { tag: '漫画完整版资源', heat: '3.6万讨论' },
];

export default function SectionTopics() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            热门话题
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            漫友们正在热议的漫画全集话题
          </p>
        </div>
        <div className="flex flex-wrap justify-center gap-3">
          {topicItems.map((item, idx) => (
            <div
              key={idx}
              className="flex items-center gap-2 bg-background-100 hover:bg-primary-50 border border-background-200/70 rounded-full px-4 py-2.5 transition-colors duration-200 cursor-pointer"
            >
              <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">#{item.tag}</span>
              <span className="text-xs text-accent-600 bg-accent-50 px-2 py-0.5 rounded-full font-medium whitespace-nowrap">{item.heat}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}